// extracted by mini-css-extract-plugin
export default {"alertInfo":"style_alertInfo__9yLRc","infoIcon":"style_infoIcon__0pOO6"};